module.exports = __webpack_public_path__ + "img/icon_3.5fe4fd4d.svg";